import { render, staticRenderFns } from "./base-button.vue?vue&type=template&id=b9ecf7c4&"
import script from "./base-button.vue?vue&type=script&lang=js&"
export * from "./base-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports